import { type RPPDomain } from '@retailer-platform/dashboard/core'
import {
  NavEntryPoint,
  NavEntryPointV3,
  NavSupportedEnvironment,
} from '@retailer-platform/dashboard/routing'
import {
  fulfillmentTestingCenterAdminRouter,
  enhancedFulfillmentTestingCenterAdminRouter,
} from './routing/fulfillmentTestingCenterAdminRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { fulfillmentTestingCenterAdminAccessControl } from './access-control/fulfillmentTestingCenterAdminAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'fulfillment-testing-center',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'fulfillment-testing-center-dashboard-tool',

    hasDevTooling: true,
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    partnerScoped: [fulfillmentTestingCenterAdminRouter],
    scoped: [enhancedFulfillmentTestingCenterAdminRouter],
  },
  navigationEntries: [
    {
      attachToV2: NavEntryPoint.Developer,
      attachToV3: NavEntryPointV3.Developer,
      subNavItems: [
        {
          type: 'item',
          llmDescription: 'Fulfillment testing center for creating and managing test orders',
          route: 'ftc-orders',
          labelId: 'fulfillmentTestingCenterDomain.title',
          position: 2,
          positionNavV2: 2,
          positionNavV3: 1,
          // this is ignored when developing locally
          environment: NavSupportedEnvironment.Dev,
          accessControl: fulfillmentTestingCenterAdminAccessControl,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
